import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ArticleRichTextSlice} ArticleRichTextSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ArticleRichTextSlice>} ArticleRichTextProps
 * @param {ArticleRichTextProps}
 */
const ArticleRichText = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`article-content ${slice.variation === 'first' ? 'lg:border-t-2' : 'border-t-2'} border-dark-grey pt-30px pb-10 md:py-[60px] mx-4 md:mx-7 lg:mx-0`}>
      <PrismicRichText
        field={slice.primary.text}
        components={{
          heading2: ({ children, text }) => <h2 className="sumup-trigger" id={`${text.split(" ").join("-").split("'").join("-").split(':').join('').split('(').join('').split(')').join('').split('--').join('-')}`}>{children}</h2>
        }}
      />
    </section>
  );
};

export default ArticleRichText;
